var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.667,
    y: 0.667,
    width: 45.333,
    height: 30.667,
    rx: 4.667,
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 1.333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.666 22.876a9.002 9.002 0 01-5.901 2.199c-5.025 0-9.099-4.121-9.099-9.204 0-5.084 4.074-9.204 9.099-9.204a9 9 0 015.901 2.198 9.001 9.001 0 015.902-2.198c5.025 0 9.098 4.12 9.098 9.204 0 5.083-4.073 9.204-9.098 9.204a9.002 9.002 0 01-5.902-2.2z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.666 22.876a9.227 9.227 0 003.197-7.005 9.227 9.227 0 00-3.197-7.006 9.001 9.001 0 015.902-2.198c5.025 0 9.098 4.12 9.098 9.204 0 5.083-4.073 9.204-9.098 9.204a9.001 9.001 0 01-5.902-2.2z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.666 22.876a9.227 9.227 0 003.197-7.005 9.227 9.227 0 00-3.197-7.006 9.227 9.227 0 00-3.196 7.006 9.228 9.228 0 003.197 7.005z",
    fill: "#FF5E00"
  })));
}
export default SvgMastercard;